import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { ValidationCodeStore } from './types'

export const useValidationCodeStore = create<ValidationCodeStore>()(
  persist(
    set => {
      return {
        timer: null,
        sendingType: null,
        setSendingType: (type: 'string') => {
          set({
            sendingType: type,
          })
        },
        codeConfirmed: null,
        setCodeConfirmed: (val: boolean) => {
          set({ codeConfirmed: val })
        },
        setTimer: (val: number) => {
          set({ timer: val })
        },
      }
    },
    {
      name: 'sendingType',
      getStorage: () => sessionStorage,
    },
  ),
)
